export const GRID_BORDER_WIDTH = 0; // DUPLICATED IN grid.less
export const GRID_ROW_HEIGHT = 32;
export const GRID_OWNERSHIP_CELL_WIDTH = 40;
export const GRID_SEMANTIC_CELL_WIDTH = 40;

export const GRID_HEADER_ROW_COUNT = 1;
export const GRID_HEADER_ROW_HEIGHT = 16;
export const GRID_HEADER_COLUMN_FILTER_WIDTH = 32;
export const GRID_HEADER_CELL_REQUIRED_GUTTER = 66;

export const GRID_TEXT_CELL_MINIMUM_WIDTH = 48;
export const GRID_TEXT_CELL_MAXIMUM_WIDTH = 250;
export const GRID_TEXT_CELL_REQUIRED_GUTTER = 20; // 16px horiontal padding and 4px horizontal gutter from the text itself

export const GRID_DATE_CELL_FIXED_WIDTH = 120;
export const GRID_NUMBER_CELL_FIXED_WIDTH = 120;

export const TEXT_LINE_HEIGHT = 21; // DUPLICATED in grid.less

export const GRID_MAX_NUMBER_OF_ROWS = 11;
